import ThemeContainer from '../theme-container/ThemeContainer';
import styles from './banner.module.less';
import { THEMES } from '../../utils/cms-utils';

const Banner = ({ className = '', mainColor = THEMES.FROST30, sticky = false, bannerText, children = null }) => (
    <ThemeContainer
        mainColor={mainColor}
        className={[className, styles.bannerContainer, sticky ? styles.stickyBanner : ''].join(' ')}
    >
        <div className={styles.bannerText} dangerouslySetInnerHTML={{ __html: bannerText }} suppressHydrationWarning />
        {children}
    </ThemeContainer>
);

export default Banner;
